<template>
  <div>
    <div class="fullview">
    <div class="loading-spacer"></div>
      <vue-loading
        type="spiningDubbles"
        color="#4169e1"
        :size="{ width: '50%' }"
      />
    </div>
  </div>
</template>

<script>
import { VueLoading } from 'vue-loading-template'

export default {
  name: 'loading',
  components: {
    VueLoading
  }
}
</script>

<style>
.fullview {
  z-index: 20;
  width: 100%;
  height: 100%;
  background: #fefefe;
  position: fixed;
  top: 0;
  left: 0;
}
.loading-spacer {
  height: 30%;
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/Loading.vue